import { useRef, useState, useEffect } from 'react';
import { change } from 'redux-form';

import { getTextWidth } from 'libs/common';
import { Content, Input } from './Multiselect.styled';

export const Multiselect = (props) => {
  const { countDisplayedIcons, className, label, disabled, input, meta, data, onChangeInput, autoWidth = true } = props;
  const [open, setOpen] = useState(false);
  const stringData = JSON.stringify(data);
  const old = useRef(stringData);
  const { name, value } = input;
  const { dispatch, form, dirty } = meta;

  const same = old.current === stringData;

  /**
   * clear on change input
   */
  useEffect(() => {
    if (!same && dirty && value?.length) {
      dispatch(change(form, name, []));
    }
  }, [same, value, dirty]);

  old.current = stringData;

  /**
   * toggle popup
   * @returns
   */
  const togglePopup = () => {
    if (disabled) {
      return;
    }
    setOpen((open) => !open);
  };

  /**
   * set value
   * @param {*} e
   * @param {*} fieldValue
   */
  const setValue = (e, fieldValue) => {
    let newValue = [...value];

    if (e.target.checked) {
      newValue.push(fieldValue);
    } else {
      newValue.splice(newValue.indexOf(fieldValue), 1);
    }

    if (newValue.length === 0) {
      newValue = '';
    }
    typeof onChangeInput === 'function' && onChangeInput(newValue);
    dispatch(change(form, name, newValue));
  };

  /**
   * get values
   * @returns
   */
  const getValues = () => {
    const items = value ?? [];
    if (!Array.isArray(items)) {
      return [];
    }

    const out = [];

    value.forEach((id) => {
      data.forEach((elem) => {
        if (id === elem.id) {
          out.push(elem);
        }
      });
    });

    return out;
  };

  /**
   * select all
   */
  const selectAll = () => {
    if (Array.isArray(data)) {
      let newValue = '';

      if (!value || value.length !== data.length) {
        newValue = data.map((elem) => {
          return elem.id;
        });
      }

      typeof onChangeInput === 'function' && onChangeInput(newValue);
      dispatch(change(form, name, newValue));
    }
  };

  const findMaxWidth = () => {
    let maxString = '';

    data.forEach((el) => {
      if (el.name.length > maxString.length) {
        maxString = el.name;
      }
    });

    return getTextWidth(maxString) + 60 + 'px';
  };

  const Cmp = props.additionalComponent;
  const values = getValues();
  const width = findMaxWidth();
  const other = {};
  if (autoWidth) {
    other.style = { width };
  }

  return (
    <Content className={className} {...other}>
      <label>{label}</label>
      <Input>
        <Cmp
          showPopup={togglePopup}
          values={values}
          setValue={setValue}
          $popupIsOpen={open}
          selectAll={selectAll}
          data={data}
          countDisplayedIcons={countDisplayedIcons}
          {...props}
        />
      </Input>
    </Content>
  );
};
